import * as React from 'react';
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarDensitySelector

} from '@mui/x-data-grid';
import PropTypes from 'prop-types';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import PlaylistAddRoundedIcon from '@mui/icons-material/PlaylistAddRounded';

import { Box } from '@mui/system';
import Stack from '@mui/material/Stack';
import { Button, styled, darken, lighten, Menu, MenuItem } from '@mui/material';
import { blackColor, dangerColor, warningColor, magentaColor, successColor } from '../../assets/jss/psstyle/psacount';


const styleMenu = {
    color: "black",
    cursor: "pointer",
    fontFamily: "Customfont !important",
    borderColor: "#bcbcbc",
    backgroundColor: "#bcbcbc",
}

const getColor = (color, mode) =>
    mode === 'dark' ? darken(color, 0.4) : lighten(color, 0.4);

const getHoverColor = (color, mode) =>
    mode === 'dark' ? darken(color, 0.1) : lighten(color, 0.1);

const getSelectedColor = (color, mode) =>
    mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);

const getSelectedHoverColor = (color, mode) =>
    mode === 'dark' ? darken(color, 0.4) : lighten(color, 0.4);

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    '& .super-app-theme--RED': {
        color: getColor(dangerColor[0], theme.palette.mode),
        '&:hover': {
            color: getHoverColor(
                dangerColor[0],
                theme.palette.mode
            ),
        },
        '&.Mui-selected': {
            color: getSelectedColor(
                dangerColor[0],
                theme.palette.mode
            ),
            '&:hover': {
                color: getSelectedHoverColor(
                    dangerColor[0]
                    , theme.palette.mode

                ),
            },
        },
    },
    '& .super-app-theme--ORANGE': {
        color: getColor(
            warningColor[0],
            theme.palette.mode
        ),
        '&:hover': {
            color: getHoverColor(
                warningColor[0],
                theme.palette.mode
            ),
        },
        '&.Mui-selected': {
            color: getSelectedColor(
                warningColor[0],
                theme.palette.mode
            ),
            '&:hover': {
                color: getSelectedHoverColor(
                    warningColor[0],
                    theme.palette.mode
                ),
            },
        },
    },
    '& .super-app-theme--MAGENTA': {
        color: getColor(magentaColor[0]),
        '&:hover': {
            color: getHoverColor(
                magentaColor[0],
                theme.palette.mode
            ),
        },
        '&.Mui-selected': {
            color: getSelectedColor(
                magentaColor[0],
                theme.palette.mode
            ),
            '&:hover': {
                color: getSelectedHoverColor(
                    magentaColor[0],
                    theme.palette.mode
                ),
            },
        },
    },
    '& .super-app-theme--BLACK': {
        color: getColor(
            blackColor,
            theme.palette.mode
        ),
        '&:hover': {
            color: getHoverColor(
                blackColor,
                theme.palette.mode
            ),
        },
        '&.Mui-selected': {
            color: getSelectedColor(
                blackColor,
                theme.palette.mode
            ),
            '&:hover': {
                color: getSelectedHoverColor(
                    blackColor,
                    theme.palette.mode
                ),
            },
        },
    },
    '& .super-app-theme--GREEN': {
        color: getColor(
            successColor[0],
            theme.palette.mode
        ),
        '&:hover': {
            color: getHoverColor(
                successColor[0],
                theme.palette.mode
            ),
        },
        '&.Mui-selected': {
            color: getSelectedColor(
                successColor[0],
                theme.palette.mode
            ),
            '&:hover': {
                color: getSelectedHoverColor(
                    successColor[0],
                    theme.palette.mode
                ),
            },
        },
    },
}));

//GREEN

export default function CustomDataGrid(props) {

    const {
        from,
        // defaultDataintable,
        datarows,
        datacolumns,
        rowHeight,
        startRow,
        option,
        customButton,
        ...rest
    } = props

    //-------------------end  snackbar ------------------------------------------
    const [optiontype, setOptiontype] = React.useState([])
    const editingRow = React.useRef(null);
    const [rows, setRows] = React.useState(datarows);
    const [delrows, setDelRows] = React.useState([]);
    const [selectionModel, setSelectionModel] = React.useState([]);

    const [enableaddicon, setEnableaddicon] = React.useState(false);
    const [enabledelicon, setEnabledelicon] = React.useState(false);
    const [enableselecticon, setEnableselecticon] = React.useState(false);
    const [enableensityicon, setEnableDensityicon] = React.useState(false);
    // for  rowSelect

    const [rowSelect, setRowsSelect] = React.useState([]);


    let idCounter = 0;
    const createRow = (data, empty) => {
        // ถ้ามีข้อมูลใน rows staet
        if (rows.length > 0) {
            const ids = rows.map(object => {
                return object.id;
            });
            const max = Math.max(...ids);
            idCounter = max
        }

        idCounter += 1;
        let lastdata
        if (empty === true) {
            let newdata = data.reduce((a, v) => ({ ...a, [v]: "" }), {})
            lastdata = { ...newdata, id: idCounter }
        }
        return lastdata
    };
    React.useEffect(() => {
        let newrows = typeof startRow !== "undefined" ? startRow : 10
        // console.log("useEffect customgrid", datarows);
        if (rows.length <= 0) {
            let field = []
            datacolumns.forEach(element => {
                if (element.field != "id") {
                    field.push(element.field)
                }
            });
            for (let index = 0; index < newrows; index++) {
                setRows((prevRows) => [...prevRows, createRow(field, true)]);
            }
        }
        return () => {

        }
    }, [])
    React.useEffect(() => {
        // console.log("datarows in  CustomDataGrid", datarows);
        // console.log("datarows in  CustomDataGrid rows", rows);
        updateRows()
        return () => {
        }
    }, [datarows])
    React.useEffect(() => {
        console.log("datarows in  CustomDataGrid rowSelect", rowSelect);
        if (rowSelect.length > 0) {
            props.Dataselect(rowSelect)
        }
        return () => {
        }
    }, [rowSelect])
    const updateRows = () => {
        if (datarows.length > 0) {
            setRows(datarows)
        } else {
            setRows([])
        }
    }
    React.useEffect(async () => {
        //console.log("rowUpdate in customdata grid", rows);
        await props.Dataintable(rows)
    }, [rows])
    React.useEffect(async () => {
        if (typeof option !== 'undefined') {
            if (option.length > 0) {
                let addenable = "", delenable = "", selectenable = "", density = ""
                option.forEach(element => {
                    if (element.add !== "") {
                        addenable = element.add
                    }
                    if (element.del !== "") {
                        delenable = element.del
                    }
                    if (element.select !== "") {
                        selectenable = element.select
                    }
                    if (element.density !== "") {
                        density === element.density
                    }
                });
                await setEnableDensityicon(density)
                await setEnableaddicon(addenable)
                await setEnabledelicon(delenable)
                await setEnableselecticon(selectenable)
            }
        }
        return () => {

        }
    }, [option])
    const processRowUpdate = async (newRow) => {
        // console.log("checkhandle processRowUpdate")
        let newRowData = []
        for (let index = 0; index < rows.length; index++) {
            if (newRow.id === rows[index].id && newRow.nameen !== "") {
                newRowData.push(newRow)
            } else {
                newRowData.push(rows[index])
            }
            //   console.log("rows ", rows[index].id)
        }
        // await console.log("rows newRowData", newRowData) 
        await setRows(newRowData)
        // setTimeout(() => {
        //     props.rowUpdate(newRow)
        // }, 300);
        return newRow
    };
    //------------------------------------------ icon
    const CustomToolbar = () => {
        return (
            <>
                <GridToolbarContainer id={`GridToolbarContainer${from}`} >

                    <Stack direction="row" spacing={2}>
                        <Button variant="outlined" startIcon={<PlaylistAddRoundedIcon />} size="small" onClick={handleAddRow}
                            style={{ display: enableaddicon === false ? "none" : "inherit" }} sx={styleMenu}
                        >
                            เพิ่มแถว
                        </Button>
                        <Button variant="outlined" startIcon={<DeleteOutlineRoundedIcon />} onClick={_ => handleDelDataClick()} size="small"
                            style={{ display: selectionModel.length > 0 ? enabledelicon === false ? "none" : "inherit" : "none" }} sx={styleMenu}>
                            ลบแถว
                        </Button>
                        {customButton}

                    
                        {enableensityicon === false ? <GridToolbarDensitySelector sx={styleMenu} /> : ""}
                    </Stack>
                </GridToolbarContainer >
            </>
        );
    }
    const handleDelDataClick = async () => {
        const selectedIDs = new Set(selectionModel);
        // you can call an API to delete the selected IDs
        // and get the latest results after the deletion
        // then call setRows() to update the data locally here
        await setRows((r) => r.filter((x) => !selectedIDs.has(x.id)));
        let row = []
        let delrow = []
        await rows.filter((x) => {
            if (selectedIDs.has(x.id)) {
                delrow.push(x)
                //  console.log("delData sssssssssssssssss", x);
            } else {
                if (x.nameen !== "") {
                    row.push(x)
                }
            }
        })
        await props.Dataintable(row)
        await props.Dataintableremove(delrow)
    }
    const handleSelectDataClick = async () => {


        console.log("button clickedssssssssssssssssss")
        const selectedIDs = new Set(selectionModel);
        let selectRows = rows.filter((x) => {
            return selectedIDs.has(x.id)
        })
        console.log("button selectRows", selectRows)
        setRowsSelect(selectRows)
    }
    // เพิ่มแถวในตาราง
    const handleAddRow = async () => {
        let field = []
        datacolumns.forEach(element => {
            if (element.field != "id") {
                field.push(element.field)
            }
        });
        console.log(field);
        //createRow(field, true) 
        await setRows((prevRows) => [...prevRows, createRow(field, true)]);
    };
    const handleContextMenu = (event) => {
        event.preventDefault();
        setState({
            ...state,
            selectedRow: Number(event.currentTarget.getAttribute("data-id")),
            contextMenu: state.contextMenu === null ? { mouseX: event.clientX - 2, mouseY: event.clientY - 4 } : null
        })
    };
    const handleClose = () => {
        // contextMenu  
        setState({
            ...state,
            contextMenu: null
        })
    };
    return (
        <Box sx={{ height: "70vh" }} style={{ width: '100%' }} component="div" >
           
              {selectionModel.length > 0
                           && enableselecticon === true 
                         ?
                            <Button variant="outlined"
                                size="small"
                                onClick={e => handleSelectDataClick()}
                                sx={styleMenu}
                            >
                                ตกลง
                            </Button>
                             : ""
                            }
            <StyledDataGrid
                sx={{
                    marginTop: 1,
                    fontFamily: "Customfont !important",
                    cursor: "pointer"
                }}
                rows={rows}
                columns={datacolumns}
                editMode='row'
                rowHeight={rowHeight}
                processRowUpdate={processRowUpdate}
                {...rest}
                onSelectionModelChange={(newSelectionModel) => {
                    setSelectionModel(newSelectionModel);
                }}
                selectionModel={selectionModel}
                experimentalFeatures={{ newEditingApi: true }}
                getRowClassName={(params) => `super-app-theme--${params.row.fontColor}`}
                components={{
                    Toolbar: CustomToolbar,
                    // LoadingOverlay: LinearProgress,
                }}

            //rowsPerPageOptions={label:"xxxxx",value:[10, 25, 50, 100] }

            />


        </Box>
    );
}

CustomDataGrid.propTypes = {
    from: PropTypes.string,
    defaultDataintable: PropTypes.any,
    datacolumns: PropTypes.array,
    datarows: PropTypes.array,
    rowHeight: PropTypes.number,
    startRow: PropTypes.number,
    option: PropTypes.any,
    customButton: PropTypes.node
}